import axios from 'axios'
import { getApiHostname } from '@/components/shared/api'
import AuthenticationProvider from '@/components/shared/security/authentication-provider'
import { router } from '@/main'
import * as routes from '@/router/route-names'
import { performLogout, refreshTokenStore } from '@/components/shared/security/auth-utils'
import store from '@/store/store'
import * as Routes from '@/router/route-names'

const instance = axios.create({
  baseURL: getApiHostname(),
  withCredentials: true,
  timeout: 60000 * 3, // 3 minutes
})

// instance.interceptors.response.use(
//   response => response,
//   async error => {
//     // Global error handling for 403s
//     const statusCode = error.response ? error.response.status : null
//     const url = error.response.config.url
//     const isInviteRequest = url.startsWith('/open/broker-invite') || url.startsWith('/open/invite')
//
//     if (statusCode === 401 && !isInviteRequest) {
//       // User is Unauthorized - likely has an expired cookie for this request.
//       const refreshResponse = await refreshToken()
//       console.log({ refreshResponse })
//       const refreshResponseCode = refreshResponse.status
//
//       if (refreshResponseCode === 205) {
//         console.log('inside 205')
//         // forced logout
//         // redirect to login
//         performLogout()
//         // This router worked, but the logout action would be way better.
//         await router.push({
//           name: routes.LOGIN_PAGE,
//         })
//         store.dispatch('setGlobalErrorAlert', {
//           show: true,
//           text: 'Your login has expired.',
//         })
//       }
//       // else {
//       // Now that I've fixed the refresh, this shouldn't happen
//       // }
//       return
//     }
//     if (statusCode === 403) {
//       // User is Forbidden for this request.
//       console.log('403 Forbidden')
//       return
//     }
//     throw error
//   }
// )

instance.interceptors.response.use(
  response => response,
  error => {
    // Global error handling for 403s
    const statusCode = error.response ? error.response.status : null
    const url = error.response?.config.url || ''
    const isOpenRequest = url.startsWith('/open')
    const isRefreshRequest = url.startsWith('/auth/refresh')

    if (isRefreshRequest) {
      // Without this - we can trigger an infinite loop.
      store.dispatch('setGlobalErrorAlert', {
        show: true,
        text: 'Your login has expired.',
      })
      performLogout()
      router.push({
        name: routes.LOGIN_PAGE,
      })

      return Promise.reject(error)
    }

    // This is a little bit of magic that lets us call /refresh only once,
    // and after the refresh, it retries the original request
    if (statusCode === 401 && !isOpenRequest) {
      // console.log('1. calling refresh ' + error.config.url)
      // User is Unauthorized - likely has an expired cookie for this request.

      const promise = refreshTokenStore(store).then(() => {
        // console.log('2. refresh finished ' + error.config.url)
        // After the refresh is complete, retry the requests
        const errorConfig = error.config
        return instance(errorConfig)
      })
      return Promise.resolve(promise)
    } else if (statusCode === 403) {
      const method = error.response?.config.method || ''
      const isModifyingRequest = ['post', 'put', 'delete', 'patch'].includes(method.toLowerCase())
      const isViewerUser = store.getters['isViewerUser']
      if (isViewerUser && isModifyingRequest) {
        // Queue the alert to show after the calling method error is handled
        setTimeout(() => {
          store.dispatch('setGlobalErrorAlert', {
            show: true,
            text: 'You are in Read Only mode. Modifications are not allowed.',
          })
        }, 0)
        return Promise.reject(error)
      } else if (router.currentRoute.name !== Routes.RESOURCE_NOT_FOUND) {
        // eslint-disable-next-line no-unused-vars
        router.push({ name: Routes.FORBIDDEN }).catch(_ => {})
        return Promise.reject(error)
      }
    } else if (statusCode === 404) {
      if (router.currentRoute.name !== Routes.FORBIDDEN) {
        // eslint-disable-next-line no-unused-vars
        router.push({ name: Routes.RESOURCE_NOT_FOUND }).catch(_ => {})
        return Promise.reject(error)
      }
    } else {
      // console.log('4. Other use case' + error.config.url)
      return Promise.reject(error)
    }
  }
)

const httpClient = axios.create({ baseURL: getApiHostname() })

httpClient.interceptors.request.use(config => {
  const jws = AuthenticationProvider.getToken()
  if (jws) {
    config.headers['Authorization'] = `Bearer ${jws}`
  }
  return config
})

function HttpClientPlugin(Vue) {
  Vue.prototype.$http = instance
  Vue.prototype.$axios = axios
}

export { instance as HttpClient, HttpClientPlugin }
